{% block postfinancecheckout_order_action_refund %}
<sw-modal variant="small"
		  :title="$tc(`postfinancecheckout-order.modal.title.refund`)"
		  @modal-close="$emit('modal-close')">

	{% block postfinancecheckout_order_action_refund_amount %}

		<mt-number-field
			:max="this.$parent.$parent.itemRefundableQuantity"
			:min="0"
			 v-model="refundQuantity"
			number-type="int"
			 :label="$tc('postfinancecheckout-order.refund.refundQuantity.label')">
		</mt-number-field>

		<div>
			{{ $tc('postfinancecheckout-order.refundAction.maxAvailableItemsToRefund') }}:
			<b>{{ this.$parent.$parent.itemRefundableQuantity }}</b>
		</div>
	{% endblock %}

	{% block postfinancecheckout_order_action_refund_confirm_button %}
	<template #modal-footer>
		<mt-button variant="primary" @click="refund()">
			{{ $tc('postfinancecheckout-order.refundAction.confirmButton.text') }}
		</mt-button>
	</template>
	{% endblock %}

	<mt-loader v-if="isLoading"></mt-loader>
</sw-modal>
{% endblock %}
